import React from 'react';
import { TextComponentProps } from '@components/text/text-props.type';
import { StyledLabel } from './label.styled';

interface LabelProps extends TextComponentProps {
  htmlFor?: string;
}

const Label = ({
  fontColor = 'darkPurple',
  stringText,
  className,
  fontSize = 'small',
  margin = 'xs',
  htmlFor,
}: LabelProps): JSX.Element => (
  <StyledLabel
    $fontColor={fontColor}
    $fontSize={fontSize}
    className={className}
    $margin={margin}
    htmlFor={htmlFor}
  >
    {stringText}
  </StyledLabel>
);

export default Label;
